import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4515a03d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile grid justify-items-center pb-10 mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-6/12" }, [
    /*#__PURE__*/_createElementVNode("video", {
      loop: "",
      autoplay: "",
      playsinline: "",
      muted: "muted"
    }, [
      /*#__PURE__*/_createElementVNode("source", {
        src: "https://res.cloudinary.com/djrfhrpvq/video/upload/v1640017623/vibes/video_rt2k8a.webm",
        type: "video/webm"
      }),
      /*#__PURE__*/_createTextVNode(" Sorry, your browser doesn't support embedded videos. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-4xl text-center mb-10 text-white font-expanded text-shadow italic" }, "SPREAD THE VIBES"),
  /*#__PURE__*/_createElementVNode("div", { class: "font-expanded text-center mb-2" }, "Cheap. Fun. Unlimited."),
  /*#__PURE__*/_createElementVNode("div", { class: "font-sans text-center" }, "Manifest your own vibes! Mint a new community vibe on the Solana blockchain and send it to a friend or celebrity, sell it, or keep it to enjoy for yourself."),
  /*#__PURE__*/_createElementVNode("div", { class: "border-4 mt-10 p-10 border-white grid justify-items-center sorry shadow-lg" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-xl text-center text-white font-expanded blink" }, " Sorry! Minting is only available on desktop. ")
  ])
], -1))
const _hoisted_2 = { class: "mobile pt-4 vibechain" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/vibechain-mobile.svg",
    alt: "VIBECHAIN",
    class: "w-full"
  })
], -1))
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "mb-2 shadow-lg border-4 border-white" }
const _hoisted_6 = {
  loop: "",
  playsinline: "",
  autoplay: "",
  muted: "muted"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Sorry, your browser doesn't support embedded videos. ")
const _hoisted_9 = { class: "mb-2 text-center" }
const _hoisted_10 = { class: "font-expanded text-xl text-shadow text-white" }
const _hoisted_11 = { class: "font-bold text-xs text-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Minted by ")
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  class: "text-center",
  style: {"display":"none"}
}
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" · ")
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid justify-items-center mb-5 mt-5 w-10/12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/short-vert-line.svg" })
], -1))
const _hoisted_19 = { class: "grid grid-cols-3 gap-6 pb-10 mb-10 justify-items-center desktop" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid justify-items-center align-items-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-9/12" }, [
    /*#__PURE__*/_createElementVNode("video", {
      loop: "",
      autoplay: "",
      playsinline: "",
      muted: "muted"
    }, [
      /*#__PURE__*/_createElementVNode("source", {
        src: "https://res.cloudinary.com/djrfhrpvq/video/upload/v1640017710/vibes/video_qik1mq.webm",
        type: "video/mp4"
      }),
      /*#__PURE__*/_createTextVNode(" Sorry, your browser doesn't support embedded videos. ")
    ])
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-6xl text-center mb-10 text-white font-expanded text-shadow italic" }, "SPREAD THE VIBES", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-expanded text-center mb-2" }, "Cheap. Fun. Unlimited.", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-sans text-center" }, "Manifest your own vibes! Mint a new community vibe on the Solana blockchain and send it to a friend or celebrity, sell it, or keep it to enjoy for yourself.", -1))
const _hoisted_24 = { class: "border-4 border-white p-4 controls shadow-lg mt-10" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid justify-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-9/12" }, [
    /*#__PURE__*/_createElementVNode("video", {
      loop: "",
      autoplay: "",
      playsinline: "",
      muted: "muted"
    }, [
      /*#__PURE__*/_createElementVNode("source", {
        src: "https://res.cloudinary.com/djrfhrpvq/video/upload/v1640017542/vibes/video_nwjoqm.webm",
        type: "video/webm"
      }),
      /*#__PURE__*/_createTextVNode(" Sorry, your browser doesn't support embedded videos. ")
    ])
  ])
], -1))
const _hoisted_26 = { class: "vibechain pt-20 pb-20 desktop" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/vibechain.svg",
    alt: "VIBECHAIN",
    class: "w-full"
  })
], -1))
const _hoisted_28 = { class: "mt-20 grid justify-items-center sm:w-9/12 md:w-9/12 lg:w-6/12 text-center" }
const _hoisted_29 = { class: "mb-2 shadow-lg border-4 border-white" }
const _hoisted_30 = {
  loop: "",
  playsinline: "",
  autoplay: "",
  muted: "muted"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Sorry, your browser doesn't support embedded videos. ")
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = { class: "font-expanded text-xl text-shadow text-white" }
const _hoisted_35 = { class: "font-bold" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Minted by ")
const _hoisted_37 = ["href"]
const _hoisted_38 = { style: {"display":"none"} }
const _hoisted_39 = ["href"]
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" · ")
const _hoisted_41 = ["href"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid justify-items-center mb-5 mt-5 w-10/12" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/short-vert-line.svg" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vibe = _resolveComponent("vibe")!
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_NFTMintForm = _resolveComponent("NFTMintForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vibes, (vibe) => {
          return (_openBlock(), _createBlock(_component_vibe, {
            key: vibe.number
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("video", _hoisted_6, [
                  _createElementVNode("source", {
                    src: vibe.cdnUrl,
                    type: "video/mp4"
                  }, null, 8, _hoisted_7),
                  _hoisted_8
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", _hoisted_10, _toDisplayString(vibe.title), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("a", {
                  class: "underline break-words",
                  href: 'https://explorer.solana.com/address/' + vibe.address,
                  target: "new"
                }, _toDisplayString(vibe.address), 9, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("a", {
                  class: "font-sans text-sm underline text-white",
                  href: 'https://explorer.solana.com/address/' + vibe.address,
                  target: "new"
                }, "Details", 8, _hoisted_15),
                _hoisted_16,
                _createElementVNode("a", {
                  class: "font-sans text-sm underline text-white",
                  href: 'https://explorer.solana.com/address/' + vibe.address,
                  target: "new"
                }, "View on Solana", 8, _hoisted_17)
              ]),
              _hoisted_18
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", null, [
        _hoisted_21,
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", null, [
            _createVNode(_component_ConfigPane)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_NFTMintForm)
          ])
        ])
      ]),
      _hoisted_25
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vibes, (vibe) => {
          return (_openBlock(), _createBlock(_component_vibe, {
            key: vibe.number,
            class: "grid justify-items-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("video", _hoisted_30, [
                    _createElementVNode("source", {
                      src: vibe.cdnUrl,
                      type: "video/mp4"
                    }, null, 8, _hoisted_31),
                    _hoisted_32
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("a", _hoisted_34, _toDisplayString(vibe.title), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("a", {
                    class: "underline",
                    href: 'https://explorer.solana.com/address/' + vibe.address,
                    target: "new"
                  }, _toDisplayString(vibe.address), 9, _hoisted_37)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("a", {
                    class: "font-sans text-sm underline text-white",
                    href: 'https://explorer.solana.com/address/' + vibe.address,
                    target: "new"
                  }, "Details", 8, _hoisted_39),
                  _hoisted_40,
                  _createElementVNode("a", {
                    class: "font-sans text-sm underline text-white",
                    href: 'https://explorer.solana.com/address/' + vibe.address,
                    target: "new"
                  }, "View on Solana", 8, _hoisted_41)
                ])
              ]),
              _hoisted_42
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ])
  ], 64))
}